export class FilterRequestTest {
  rol: String;
  estados: String;
  fechaInicial: String;
  fechaFinal: String;
  cedula: String;
  registros: String;
  pagina: String;
  pruebas: String;
}
